// frontend/src/services/api/videos.js - FAST DIRECT UPLOAD
import { apiClient } from '../api';
import axios from 'axios';

export const videosAPI = {
  /**
   * FAST UPLOAD: Get pre-signed URL then upload directly to R2
   */
  createVideo: async (videoFile, metadata, onProgress) => {
    try {
      // Validate inputs
      if (!videoFile || !videoFile.name || !videoFile.type) {
        throw new Error('Invalid video file. File must have name and type properties.');
      }

      console.log('🚀 Starting upload for:', videoFile.name, videoFile.type);

      // Step 1: Get pre-signed URL from backend (FAST - only metadata)
      console.log('🚀 Step 1: Getting upload URL...');
      const urlResponse = await apiClient.post('/videos/upload-url', {
        filename: videoFile.name,
        contentType: videoFile.type,
      });

      if (!urlResponse.data || !urlResponse.data.uploadUrl || !urlResponse.data.publicUrl) {
        throw new Error('Invalid response from server when requesting upload URL');
      }

      const { uploadUrl, publicUrl } = urlResponse.data;
      console.log('✅ Upload URL received');

      // Step 2: Upload directly to R2 (FAST - bypasses backend!)
      console.log('🚀 Step 2: Uploading directly to R2...');
      await axios.put(uploadUrl, videoFile, {
        headers: {
          'Content-Type': videoFile.type,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (onProgress) {
            onProgress(percentCompleted);
          }
          console.log(`📤 Upload progress: ${percentCompleted}%`);
        },
      });

      console.log('✅ Video uploaded to R2!');

      // Step 3: Save metadata to database
      console.log('🚀 Step 3: Saving metadata...');
      const completeResponse = await apiClient.post('/videos/complete', {
        videoUrl: publicUrl,
        ...metadata,
        fileSize: videoFile.size,
        mimeType: videoFile.type,
      });

      console.log('✅ Upload complete!');
      return completeResponse.data;

    } catch (error) {
      console.error('❌ Upload error:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      throw error;
    }
  },

  // Get all videos (with optional filters)
  getVideos: async (params = {}) => {
    const response = await apiClient.get('/videos', { params });
    return response.data;
  },

  // Get videos by location (for map view)
  getVideosByLocation: async (latitude, longitude, radius = 50) => {
    const response = await apiClient.get('/videos/nearby', {
      params: { latitude, longitude, radius }
    });
    return response.data;
  },

  // Get single video by ID
  getVideoById: async (videoId) => {
    const response = await apiClient.get(`/videos/${videoId}`);
    return response.data;
  },

  // Update video
  updateVideo: async (videoId, data) => {
    const response = await apiClient.put(`/videos/${videoId}`, data);
    return response.data;
  },

  // Delete video
  deleteVideo: async (videoId) => {
    const response = await apiClient.delete(`/videos/${videoId}`);
    return response.data;
  },

  // Increment view count
  incrementViews: async (videoId) => {
    const response = await apiClient.post(`/videos/${videoId}/view`);
    return response.data;
  },

  // Like/unlike video
  toggleLike: async (videoId) => {
    const response = await apiClient.post(`/videos/${videoId}/like`);
    return response.data;
  },

  // Get user's videos
  getUserVideos: async (userId) => {
    const response = await apiClient.get(`/videos/user/${userId}`);
    return response.data;
  },

  // Boost video back to map
  boostVideo: async (videoId, expiryDays = 7) => {
    const response = await apiClient.post(`/videos/${videoId}/boost`, { expiryDays });
    return response.data;
  },
};

export default videosAPI;
